export default {"src":"/_next/static/media/print.b02966f2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};